import AppRoutes from './routers/Routers';

import './App.css'
import './i18n';

function App() {
  return (
    
    <div className="App">
      <AppRoutes />
    </div>

  );
}

export default App;
